module.exports = __webpack_public_path__ + "public/images/header-slide-2.6443b2283ddb99f377474f0d4bc6a6e7.jpeg";